
/// ContactBar
import React from 'react';
import config from '../config';
import { Icon } from 'semantic-ui-react';
import '../style/App.css';

class ContactBar extends React.Component{
    render(){
        return(
            <div>
                {config.website.footer.contact.map(s => (
                    <div style={Style.label}><Icon name={s.id}/>
                        {s.text}
                    </div>
                ))}
            </div>
        )
    }
};

const Style = {
    label: {    
        fontSize: '20px',
        fontWeight: '300',
        width: 'auto',
        height: '3rem',
    }
}
export default ContactBar;


// WEBPACK FOOTER //
// ./src/components/ContactBar.js